import { ReactElement, useState } from 'react'

import { CommonCloseIcon, CommonQuestionIcon } from '@local/assets/icons'

import Clickable from '@web/components/Clickable'
import { Nullish } from '@web/types'

import styles from '../MissionCard.module.scss'

export interface DescriptionProps {
  text: ReactElement | string
  guide?: Nullish<ReactElement | string>
  nClickArea?: {
    openGuide: string
    closeGuide: string
  }
}

const Description = ({ text, guide, nClickArea }: DescriptionProps) => {
  const [showGuideLayer, setShowGuideLayer] = useState(false)
  const handleShowGuideLayer = () => {
    setShowGuideLayer(!showGuideLayer)
  }

  return (
    <div className={styles.description_area}>
      {text}
      {guide && (
        <Clickable className={styles.btn_guide} onClick={handleShowGuideLayer} nClickCode={nClickArea?.openGuide}>
          <CommonQuestionIcon className={styles.icon} aria-hidden="true" />
          <span className="place_blind">안내</span>
        </Clickable>
      )}
      {showGuideLayer && (
        <div className={styles.ly_guide}>
          {guide}
          <Clickable className={styles.btn_close} onClick={handleShowGuideLayer} nClickCode={nClickArea?.closeGuide}>
            <CommonCloseIcon className={styles.icon} aria-hidden="true" />
            <span className="place_blind">안내레이어 닫기</span>
          </Clickable>
        </div>
      )}
    </div>
  )
}

export default Description
